module.exports = __webpack_public_path__ + "assets/img/志愿组织.dd450bf2.png";